// extracted by mini-css-extract-plugin
module.exports = {"tuvCertificateMessage":"TuvCertificateMessage_tuvCertificateMessage__8zkKa"};